import { render } from "./UnfoldMoreHorizontal.vue?vue&type=template&id=5f6bc0cc"
import script from "./UnfoldMoreHorizontal.vue?vue&type=script&lang=js"
export * from "./UnfoldMoreHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__